import styled from "styled-components";
import AppBar from "@mui/material/AppBar";
import type { Theme } from "../../../constants/themeConstants";
import { Accordion, Box, Drawer, List } from "@mui/material";
import BgImage from "../../../assets/vertical-bg.jpg";
import IconButton from "@mui/material/IconButton";

export const HeaderContainer = styled(AppBar)`
  && {
    padding: 0;
    background-color: ${(props) => (props.theme as Theme)?.colors?.white};

    .MuiContainer-root {
      padding: 5px 0 5px 16px;
    }

    .MuiToolbar-root {
      gap: 48px;
      justify-content: space-between;
    }
  }
`;

export const LogoContainer = styled.div``;
export const IconButtonStyled = styled(IconButton)`
  && {
    margin-left: auto;

    &:active,
    &:focus {
      outline: none;
    }
  }
`;

export const Logo = styled.picture`
  width: auto;
`;

export const DrawerContainer = styled(Drawer)``;

export const DrawerContnet = styled(Box)`
  color: ${({ theme }) => (theme as Theme).colors.white};
  background-image: linear-gradient(
      ${({ theme }) => (theme as Theme).colors.dark}df
    ),
    url(${BgImage});
  background-color: ${({ theme }) => (theme as Theme).colors.dark};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;

  min-height: fit-content;
  height: 100%;

  display: flex;
  flex-direction: column;

  &&,
  && * {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0;
  }
`;

export const SocialNetworksContent = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 16px 16px 16px;
`;

export const MenuList = styled(List)`
  && {
    margin-top: 32px;
    padding-top: 0;
    padding-bottom: 0;
    & > li .MuiListItemButton-root,
    & a {
      padding: 12px 16px;
      margin-bottom: 16px;
      color: ${(props) => (props.theme as Theme)?.colors?.white};
    }
  }
`;

export const MenuDropdownItem = styled(Accordion)`
  && {
    background-color: transparent;
    --Paper-shadow: 0 !important;
    color: ${(props) => (props.theme as Theme)?.colors?.white};

    &:active,
    &:focus,
    .MuiAccordionSummary-root:focus {
      outline: none;
    }
    .MuiAccordionSummary-root {
      min-height: 44px;
      margin-bottom: 16px;
    }
    .MuiAccordionSummary-content,
    .MuiAccordionSummary-content.Mui-expanded {
      margin: 0;
      min-height: 44px;
      //align-items: center;
      & > svg {
        margin-top: 8px;
      }
    }
    .MuiList-root {
      padding: 0;
    }

    .MuiAccordion-root {
      padding: 0;
    }
    .MuiAccordionDetails-root {
      margin: 0 16px;
    }

    & li {
      .MuiListItemButton-root {
        padding: 0;
        margin-bottom: 20px;
      }

      &:last-of-type .MuiListItemButton-root {
        margin-bottom: 0;
      }
      .MuiTypography-root {
        font-size: 16px;
      }
    }
  }
`;

export const DropdownButtonTitle = styled(Box)`
  && {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 6px; //8px;
    text-decoration: none;
    text-transform: initial;
    justify-content: center;

    span {
      line-height: 20px;
      padding: 0 8px;
    }
  }
`;
